import { render, staticRenderFns } from "./CategoriesListDrawer.vue?vue&type=template&id=5ff173e8&scoped=true"
import script from "./CategoriesListDrawer.vue?vue&type=script&lang=ts"
export * from "./CategoriesListDrawer.vue?vue&type=script&lang=ts"
import style0 from "./CategoriesListDrawer.vue?vue&type=style&index=0&id=5ff173e8&prod&scoped=true&lang=css"
import style1 from "./CategoriesListDrawer.vue?vue&type=style&index=1&id=5ff173e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff173e8",
  null
  
)

export default component.exports